import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/lib/content-context";
import LandingPage from "@/pages/LandingPage";
import FreeAccessPage from "@/pages/FreeAccessPage";
import FaqPage from "@/pages/FaqPage";
import DownloadsPage from "@/pages/DownloadsPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/free-access" element={<FreeAccessPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </ContentProvider>
  );
}

export default App;
